import React from 'react';
import { Check, Circle, X } from 'lucide-react';

/**
 * Generic stage checklist for a record's lifecycle (e.g. Inward or Dispatch).
 * steps: [{ label: string, state: 'done' | 'current' | 'pending' | 'rejected' }]
 */
const WorkflowTimeline = ({ steps }) => {
  return (
    <div className="zip-card p-5">
      <h3 className="font-semibold text-zip-text tracking-tight mb-4">Workflow Status</h3>
      <ol className="space-y-2">
        {steps.map((step, i) => {
          const isDone = step.state === 'done';
          const isCurrent = step.state === 'current';
          const isRejected = step.state === 'rejected';
          return (
            <li key={i} className="flex items-center gap-3 text-sm">
              <span
                className={
                  'flex items-center justify-center w-5 h-5 rounded-full shrink-0 ' +
                  (isDone
                    ? 'bg-emerald-100 text-emerald-600'
                    : isRejected
                    ? 'bg-red-100 text-red-600'
                    : isCurrent
                    ? 'bg-zip-red/10 text-zip-red'
                    : 'bg-zip-surface text-zip-muted border border-zip-border')
                }
              >
                {isDone ? <Check size={12} /> : isRejected ? <X size={12} /> : <Circle size={7} fill="currentColor" />}
              </span>
              <span
                className={
                  isDone
                    ? 'text-zip-text'
                    : isCurrent
                    ? 'text-zip-text font-semibold'
                    : isRejected
                    ? 'text-red-600 font-medium'
                    : 'text-zip-muted'
                }
              >
                {step.label}
              </span>
            </li>
          );
        })}
      </ol>
    </div>
  );
};

export default WorkflowTimeline;
